<template>
  <div>
    <v-layout align-start justify-left wrap>
      <v-flex>
        <v-card
          :color="navColor"
        >
          <v-card-text class="white--text">
            <div class="headline mb-2">{{title}}</div>
            <div>{{totalAmount | price('INR')}}</div>
          </v-card-text>
          <v-data-table
            :loading="isDataLoading"
            :headers="headers"
            :items="result.rows"
            :items-per-page="15"
            :sortBy="[ filters.length > 1 ? 'price_1' : 'price_0']"
            :sortDesc="['desc']"
            @click:row="onRowClick"
            dense
            item-key="category.key"
          >
            <template v-slot:item.category="{ item }">
              <div>{{item.category.category.name}}</div>
            </template>
            <template v-for="(slotName, ci) in slots" v-slot:[slotName]="{ item }">
              <div
                class="clickableCell"
                :key="slotName" @click="viewTransactions(item, ci)"
                :class="{activeCell: `${item.category.key}_${ci}` === selectedItemKey}"
              >{{item[`price_${ci}`] | price('INR')}}</div>
            </template>
            <template slot="body.prepend">
              <tr>
                <th>Total</th>
                <template v-for="(slotName, ci) in slots">
                  <th :key="slotName" class="text-end">{{result.results[ci].cursor.sum | price('INR')}}</th>
                </template>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<style lang="scss" scoped>
  .clickableCell {
    &:hover {
      cursor: pointer;
      color: blue;
    }
  }
  .activeCell {
    color: green;
  }
</style>

<script>
import { DataState } from '@/state'
import { Transaction } from '@/models/transaction'
export default {
  props: {
    title: String,
    selectedItemKey: String,
    filters: {
      type: Array
    },
    navColor: {
      type: String,
      default: '#385F73'
    },
  },
  watch: {
    'filters' (val) {
      this.fetch()
    }
  },
  data () {
    return {
      state: DataState.newLoading(),
      result: {},
      totalAmount: 0,
      headers: [],
      slots: [],
      ignored: ['Between Accounts', 'Invalid Return', 'CapturedTax', 'Invalid Entry']
    }
  },
  computed: {
    isDataLoading () {
      return this.state && this.state.isLoading()
    }
  },
  mounted () {
    this.onLoaded()
  },

  methods: {
    onLoaded () {
      this.fetch()
    },
    fetch () {
      this.state.changeToLoading()
      let params = this.filters.map(x => Object.assign({}, x))
      Transaction.categoryReportTable(params).then(response => {
        this.result = response
        this.headers = [
          { text: 'Category', value: 'category' }
        ]
        this.slots = []
        this.totalAmount = 0
        this.result.filters.forEach((filter, i) => {
          this.headers.push({
            text: `${filter.title || i}`,
            value: `price_${i}`,
            align: 'end'
          })
          this.slots.push(`item.price_${i}`)
          if (this.result.results[i].cursor.sum) {
            this.totalAmount += this.result.results[i].cursor.sum
          }
        })
        this.state.changeToLoaded()
      }).catch(error => {
        this.state.changeToError(error)
      })
    },

    viewTransactions (item, i) {
      const filter = this.filters[i].clone()
      filter.category = item.category.key
      const key = `${filter.category}_${i}`

      this.$emit('rowClick', item, filter, key)
    }
  }
}
</script>
